import { useFormik } from "formik";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import * as yup from "yup";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";
import { useEffect, useMemo, useState } from "react";
import Input, { NuInput, NuInputWithError, NuSelect, NuTextArea, NuUpload } from "../../../../Components/Utils/Input";
import FormikSelectTwo, { SelectProductWithError } from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import DropDownAddMetaData, { DropDownAddUnitWithError } from "../../../../Components/Utils/selectAddMetaData";
import UseDropDownNew from "../../../../Components/Hooks/useDDNew";
import { useParams } from "react-router-dom";
import { useNumber } from "../../../../Context/ProjectIdContext";
import { useToast } from "../../../../Components/Others/ToastServices";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import DeleteIcon from "../../../../Components/Icons/Delete";
import EditIcon from "../../../../Components/Icons/Edit";
import Select from "react-select";

import UseProductDropDownNew from "../../../../Components/Hooks/useProductSearch";
import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
import DropDownAddSubCategory from "../../../../Components/Utils/selectAddSubCategory";
import DropDownAdd from "../../../../Components/Utils/selectAdd";
const filetype = [
  "docx",
  "doc",
  "xlsx",
  "xls",
  "pdf",
  "txt",
  "pptx",
  "mp4",
  "mov",
  "wmv",
  "avi",
  "flv",
  "mkv",
];

const CreateRequest = () => {
  const {officeId} =useParams();

  const {value:RequestFor ,getData:refRequestFor} = useFetchMataData(`/dropdown/dropdown-details/`,'RequestFor')
  const {value:PurposeOfRequest ,getData:refPurposeOfRequest} = useFetchMataData(`/dropdown/dropdown-details/`,'PurposeOfRequest')
  // const { value:Unit, getData:refUnit } = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')
  // const {value:RequestStatus} = useFetchMataData(`/dropdown/dropdown-details/`,'RequestStatus')
  // const [loading, setLoading] = useState(false);
  const {number} = useNumber()
const [items, setItems] = useState([]);
  console.log(items, "ii");
  const [newItemData, setNewItemData] = useState({
    productId:"",
    purpose:"",
    quantity:"",
    returnedQty:"",
    unit:""
  });
   const [isEditQua, setIsEditQua] = useState(false);
    const [isEditUnit, setIsEditUnit] = useState(false);
   
  const { Oncancel, addFormData, isLoading } = useAddFormData();
  const [createNew, setCreateNew] = useState({
    requestFor: "",
    purpose: "",
    isReturnable: false,
    item: "",
    comments: "",
    issuedBy:"",
    branchId:officeId,
    projectId:number,
    products:"",

    
  });
  
  const [error, setError] = useState("");
  const [Requestslist, setRequestslist] = useState([]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // item: yup.string().required('Product is required!'),
      // quantity: yup.string().required('Quantity is required!'),

    }),
    onSubmit: async (value, { resetForm }) => {
    //  setLoading(true)
    if (items.length === 0) {
      setError("Product table is empty");
      // setLoading(false)

      return;
    }
    let formData = new FormData();
    const valueWithItems = {
      ...value,
      products: items,
    };
   
    formData.append("json_data", JSON.stringify(valueWithItems));
    if (selectedFile !== null) {
      selectedFile.forEach((file) => {
        formData.append("attachments", file);
      });
    } else {
      formData.append("attachments", []);
    }
    // formData.append('attachments', image.raw);

      addFormData("/requests/new-request", formData, resetForm);
      // setLoading(false)
    },
  });
const [selectedFile, setSelectedFile] = useState(null);
  const toast = useToast();
  const [image, setImage] = useState([]);

  function handleImageChange(e) {
  const maxFileSize = 200000000; // 200 MB
  const files = Array.from(e.target.files);
  let fileArr = [];

  files.forEach((item) => {
    if (item.size < maxFileSize) {
      fileArr.push(item);
    } else {
      toast.open({
        type: "warning",
        message: `File Size too big`,
        description: `${item.name} is removed and not uploaded`,
      });
    }
  });

  let tempArr = [];
  setSelectedFile(fileArr);

  fileArr.forEach((item) => {
    let fileName = item?.name;
    tempArr.push(fileName);
  });

  setImage(tempArr);
  console.log(tempArr, "temp");

  // 👉 Reset input so same file can be selected again
  e.target.value = null;
}
  const removeImages = (value) => {
    console.log("value", value);
    let List = selectedFile.filter((item) => item?.name !== value);
    console.log("LIst", List);
    setSelectedFile([...List]);
    let tempArr = [];
    List.map((item) => {
      let fileName = item?.name;
      tempArr.push(fileName);
    });
    setImage(tempArr);
  };
    const [search, setSearch] = useState("");
  
  const [sortedProList,setSortedProList] =  useState([]);
  const [oldData, setOldData] = useState([])
  const { data: Item, setData } = UseProductDropDownNew(
    `/items/new-drop-down/${officeId}/branch`,
    search
  ); 
  const { data: user } = UseDropDown('/user/drop-down');
  const { value: Unit, getData: refUnit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Unit_item"
  );
     const [productError, setProductError] = useState("");
    const [unitError, setUnitError] = useState("");
    const [quantityError, setQuantityError] = useState("");
    const handleAdd = () => {
      let hasError = false;
  
      if (!formik.values.productId) {
        setProductError("Product is required");
        hasError = true;
      } else {
        setProductError("");
      }
  
      if (!formik.values.unit) {
        setUnitError("Unit is required");
        hasError = true;
      } else {
        setUnitError("");
      }
  
      if (!formik.values.quantity) {
        setQuantityError("Quantity is required");
        hasError = true;
      } else {
        setQuantityError("");
      }
  
      if (hasError) return;
  
      if (formik.values.productId && formik.values.quantity) {
        const selectedProduct = Item.find(
          (i) => i.value === formik.values.productId
        );
        const newItem = {
          productId: formik.values.productId,
          productName: sortedProList.find((i) => i.value === formik.values.productId),
          quantity: formik.values.quantity,
          // unit:selectedProduct.unit
          unit: formik.values.unit,
        };
        setItems([...items, newItem]);
  
        setNewItemData({
          productId: "",
          quantity: "",
          unit: "",
          // unit:""
        });
        let updatedItems = Item.filter(
          (it) => it.value !== formik.values.productId
        );
        setData(updatedItems);
        formik.values.productId = "";
        formik.values.quantity = "";
        formik.values.unit = "";
        setError("");
      }
    };
  
    const handleQuantityChange = (e, index) => {
      const updatedQuantity = e.target.value;
  
      // Update the specific item's quantity
      const updatedItems = items.map((item, idx) => {
        if (idx === index) {
          return { ...item, quantity: updatedQuantity };
        }
        return item;
      });
  
      setItems(updatedItems); // Update the state with new quantity
    };
  
    const handleProductUnitChange = (value, index) => {
      const updatedItems = items.map((item, idx) => {
        if (idx === index) {
          return { ...item, unit: value?.value };
        }
        return item;
      });
      setItems(updatedItems);
    };
  
    const handleDeleteItem = (indexToDelete) => {
      const updatedItems = items.filter((_, index) => index !== indexToDelete);
      let ddUpdatedItem = items.find((_, i) => i === indexToDelete);
      setItems(updatedItems);
      let tempDd = ddUpdatedItem.productName;
      setData([...Item, tempDd]);
      // localStorage.setItem("items", JSON.stringify(updatedItems));
    };
    const [showPop, setShowPop] = useState(false);

    const togglePop = () => {
      setShowPop(!showPop);
    };
  
    const resetForm = () => {
      formik.values.productName = "";
      formik.values.unit = "";
      formik.values.category = "";
      formik.values.subCategory = "";
      setShowPop(false);
    };
  
    const handlePopSubmit = async (e) => {
      e.preventDefault();
  
      const formData = new FormData();
      formData.append(
        "json_data",
        JSON.stringify({
          productName: formik.values.productName,
          unit: formik.values.unit,
          category: formik.values.category,
          subCategory: formik.values.subCategory,
        })
      );
  
      try {
        const response = await axiosInstance.post("/items/new-item", formData);
        const createdProduct = response.data?.data;
  
        setData((prevProducts) => [
          {
            label: formik.values.productName,
            value: createdProduct.id,
            unit: createdProduct.unit,
          }, // Add the new product at the start
          ...prevProducts,
        ]);
  
        resetForm();
      } catch (error) {
        console.error("Error creating new product:", error);
      }
    };
    const {
      category: itemsCategory,
      subCategory: itemsSubCategory,
      getCategory,
      fetchSubCategory,
    } = UseCatSubCatDropDown(
      "/category/ItemCategory",
      "ItemCategory",
      formik?.values?.category
    );
  
  
  
    useEffect(()=>{
      if(Item){
        const union = Array.from(
          new Map([...Item, ...oldData].map((item) => [item.value, item])).values()
        );
        let data = union.sort((a, b) => a.label.localeCompare(b.label))
        setSortedProList(data)
      }    
    },[Item])
  
    useEffect(() => {
      if (formik.values.productId) {
        const findValue = sortedProList.filter((v) => formik.values?.productId ==(v.value));
        setOldData(findValue);
      }
      console.log("Testing",formik.values.productId);
    },[formik.values.productId])
  
  return (
    <div className="w-full h-full py-2 px-4 ">
      <div className="flex justify-end ">
      {/* <Breadcrumb
         items={
          [
            { name: "Store",
            link: `/main/${officeId}/store/requests` },
          {
            name: "Request",
            link: `/main/${officeId}/store/requests`
          },
          {
            name: "Create Request"
          }]
         }
        /> */}
        <BackButton />
      </div>
      <div className="w-full h-[calc(100vh-145px)] overflow-y-auto">
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full pt-2 mx-auto pb-4 bg-white rounded-md ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap   mb-4">
            <div className="w-full">
  <p className='py-2 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4'>
 Request Create :
  </p>
</div>   
          <DropDownAddMetaData
                label="Request For"
                placeholder="Choose"
                Options={RequestFor}
                formik={formik}
                name="requestFor"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refRequestFor}
                displayProperty={"Request For"}
                propertyName={"RequestFor"}

              /> 
          
             <DropDownAddMetaData
                label="Purpose Of Request"
                placeholder="Choose"
                Options={PurposeOfRequest}
                formik={formik}
                name="purpose"
                width="w-full md:w-1/2 lg:w-1/3"
                getFunc={refPurposeOfRequest}
                displayProperty={"Purpose Of Request"}
                propertyName={"PurposeOfRequest"}
                FixPosition={true}
                PortalTarget={false}
              />
                 <FormikSelectTwo
                      label="Is Returnable"
                      placeholder="Choose"
                      Options={[
                        { value: true , label: "Yes"},
                        { value: false , label: "No"},
                      ]}
                      formik={formik}
                      name="isReturnable"
                      width="w-full md:w-1/2 lg:w-1/3"
                      FixPosition={true}
                PortalTarget={false}
                    />
                   <FormikSelectTwo
                      label="Issued By"
                      placeholder="Choose"
                      Options={user}
                      formik={formik}
                      name="issueedBy"
                      width="w-full md:w-1/2 lg:w-1/3"
                      FixPosition={true}
                PortalTarget={false}
                    />                   
                    <NuTextArea
                      label="Comments"
                      placeholder="Comments"
                      formik={formik}
                      name="comments"
                      width="w-full md:w-1/2 lg:w-1/3"
                    />
                     <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div>

              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              />
               </div>
               </div>
               <div className="w-full mx-auto  bg-white rounded-md pb-4 mt-4 ">
            <div className=" w-full h-full flex justify-start content-start flex-wrap  mb-4">
              <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Request Items :
                </p>
              </div>
              <div className="w-full px-2 m-2 flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-start gap-3 border border-solid rounded-lg">
                <SelectProductWithError
                  type="text"
                  label="Product "
                  placeholder="Product "
                  Options={sortedProList}
                  formik={formik}
                  name="productId"
                  width="w-full md:w-1/2 lg:w-[67%]"
                  ErrMessage={productError}
                  px="0"
                  handleClick={togglePop}
                  setSearch={setSearch}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <DropDownAddUnitWithError
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={formik}
                  name="unit"
                  width="w-full md:w-1/2 lg:w-1/4"
                  getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  ErrMessage={unitError}
                  FixPosition={true}
                  PortalTarget={false}
                />
                {/* <button
                  onClick={togglePop}
                  type="button"
                  className=" p-3 py-2 mt-9  text-center h-8 cursor-pointer bg-[#048178] border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                  >
                  
                  +
                </button> */}
                <NuInputWithError
                  label="Quantity"
                  type="number"
                  formik={formik}
                  placeholder="Quantity"
                  name="quantity"
                  width="w-full md:w-1/2 lg:w-1/4 "
                  ErrMessage={quantityError}
                />
                <button
                  onClick={handleAdd}
                  type="button"
                  className=" p-1 mt-8 m-1 text-center h-8 cursor-pointer bg-textColor-main border border-solid border-white  text-xs font-medium  text-white  rounded-lg "
                >
                  Add
                </button>
              </div>
              <div className="w-full bg-white overflow-y-scroll mt-5">
                {error && (
                  <p className="text-xs font-semibold text-red-500">{error}</p>
                )}
                <div className="w-full py-3  bg-textColor-main flex justify-between rounded-lg px-6">
                  <p className="w-[5%]  text-left  text-white text-xs font-medium">
                    S.No{" "}
                  </p>

                  <p className=" w-[55%] text-left text-white text-xs font-medium">
                    Product
                  </p>
                  <p className=" w-[15%] text-center pl-4 text-white text-xs font-medium flex justify-center">
                    Unit
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditUnit((prv) => !prv);
                      }}
                    >
                      {isEditUnit === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditUnit === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>
                  <p className=" w-[20%] text-center  text-white text-xs font-medium flex justify-center">
                    Quantity
                    <span
                      className="pl-1 cursor-pointer"
                      onClick={() => {
                        setIsEditQua((prv) => !prv);
                      }}
                    >
                      {isEditQua === true && (
                        <EditIcon width={"14"} height={"14"} color="yellow" />
                      )}
                      {isEditQua === false && (
                        <EditIcon width={"14"} height={"14"} />
                      )}
                    </span>
                  </p>

                  <p className=" w-[5%] text-right text-white text-xs font-medium">
                    Action
                  </p>
                </div>
                {items?.length > 0 ? (
                  <div className="h-[calc(100vh-300px)] overflow-y-scroll">
                    {items.map((List, index) => {
                      return (
                        <div
                          key={index}
                          className="w-full py-2 flex justify-between px-6  odd:bg-white even:bg-slate-50"
                        >
                          <p className="w-[5%]  text-left   text-xs font-medium text-[#111537] py-2.5">
                            {index + 1}
                          </p>
                          <p className=" w-[55%] text-left  text-xs font-medium text-[#111537] py-2.5">
                            {List?.productName?.label||""}
                          </p>
                          <p className=" w-[15%] text-center pl-4  text-xs font-medium text-[#111537]">
                            {/* {List?.unit} */}
                            <Select
                              value={
                                Unit.find(
                                  (item) => item?.value == List.unit
                                ) || List.unit
                              }
                              options={isEditUnit ? Unit : []}
                              className="w-full"
                              onChange={(value) =>
                                handleProductUnitChange(value, index)
                              }
                              isDisabled={!isEditUnit}
                            />
                          </p>

                          <p className=" w-[20%] text-center   text-xs font-medium text-[#111537] py-2.5">
                            <input
                              type="number"
                              className=" w-11/12 mx-auto outline-none text-center"
                              value={List?.quantity}
                              disabled={!isEditQua}
                              onChange={(e) => handleQuantityChange(e, index)}
                            />
                          </p>

                          <div className="w-[5%] text-right py-2.5">
                            <button
                              onClick={() => handleDeleteItem(index)}
                              type="button"
                              className="text-red-500 cursor-pointer  ml-4 border-none"
                            >
                              <DeleteIcon color="red" height={14} />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="w-full text-center text-[#93949f]">
                    No Items here
                  </div>
                )}
              </div>
              <div className="w-full mx-auto my-4 mt-8 pb-2">
                <div className="flex justify-end gap-4">
                  <CancelButton
                    handleClick={() => {
                      Oncancel(-1);
                    }}
                  />
                  <SubmitButton isLoading={isLoading} />
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      {showPop && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll ">
            <h2 className="text-lg font-medium text-[14px]">Add Product</h2>
            <form onSubmit={handlePopSubmit}>
              <div className="mb-4 flex flex-wrap">
                <NuInput
                  label="Product Name"
                  type="text"
                  formik={formik}
                  placeholder="Product Name"
                  name="productName"
                  width="w-full"
                  isRequired={true}
                />

                <DropDownAddMetaData
                  label="Unit"
                  placeholder="Choose"
                  Options={Unit}
                  formik={formik}
                  name="unit"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={refUnit}
                  displayProperty={"Add Unit"}
                  propertyName={"Unit_item"}
                  isRequired={true}
                  FixPosition={true}
                  PortalTarget={false}
                  
                />
                <DropDownAdd
                  type="text"
                  label="Category"
                  placeholder="Category"
                  Options={itemsCategory}
                  formik={formik}
                  name="category"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={getCategory}
                  categoryName={"ItemCategory"}
                  displayProperty={"Add Category"}
                  isRequired={true}
                  FixPosition={true}
                  PortalTarget={false}
                />
                <DropDownAddSubCategory
                  type="text"
                  label="Sub-Category"
                  placeholder="Sub-Category"
                  Options={itemsSubCategory}
                  formik={formik}
                  name="subCategory"
                  width="w-full md:w-1/2 lg:w-1/2"
                  getFunc={fetchSubCategory}
                  category={formik?.values?.category}
                  module={"ItemCategory"}
                  displayProperty={"Add Sub-Category"}
                  FixPosition={true}
                  PortalTarget={false}
                />

              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={togglePop}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2]  hover:bg-gray-300
                  rounded-md flex items-center mr-2 text-textColor-main"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="bg-textColor-main px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                >
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateRequest;
